"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/styles");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _reactRouterDom = require("react-router-dom");
var _StyledButton = _interopRequireDefault(require("shared/dist/components/StyledButton"));
var _pageNotFound = _interopRequireDefault(require("shared/dist/assets/images/pageNotFound.png"));
var _AnchorLink = _interopRequireDefault(require("shared/dist/components/AnchorLink"));
var _styles2 = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PageNotFound = _ref => {
  let {
    classes,
    homePath
  } = _ref;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const handleGoToHome = () => {
    if (homePath) {
      navigate(homePath);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: classes.pageNotFoundContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: classes.mediaContentContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    className: classes.mediaContiner
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _pageNotFound.default,
    title: "Page Not Found",
    alt: "Page not found"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    className: classes.contentContainer
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3"
  }, "Page not found!"), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "The page that you are trying to access is moved, currently down or never existed. Please check the URL."), /*#__PURE__*/_react.default.createElement(_StyledButton.default, {
    type: "transparentBlueBorder",
    btnText: "go to home",
    onClick: handleGoToHome
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: classes.description
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "If you are seeing this message repeatedly, let us know at", " ", /*#__PURE__*/_react.default.createElement(_AnchorLink.default, {
    label: "support@singularitynet.io",
    href: "/"
  }), " and we will look into it.")));
};
PageNotFound.propTypes = {
  handleGoToHome: _propTypes.default.func
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(PageNotFound);